import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StackedScrollGallery from "./components/ImageSection";
import CTASection from "./components/CTASection";
import ArtistMessageSection from "./components/ArtistMessageSection";
import TextCarouselSeciton from "./components/TextCarouselSection";
import GlobalStageSection from "./components/GlobalStageSection";
import AboutSection from "./components/AboutSection";
import PlatformSection from "./components/PlatformSection";
import PartnersSection from "./components/PartnersSection";
import { getMobileInstallUrl, isMobileInstallDevice } from "./utils/install";

const HomePage = () => {
  const [installModalOpen, setInstallModalOpen] = useState(false);
  const handleInstall = () => {
    if (isMobileInstallDevice()) {
      window.location.href = getMobileInstallUrl();
      return;
    }

    setInstallModalOpen(true);
  };

  return (
    <>
      <Header />

      <StackedScrollGallery />
      <GlobalStageSection />
      <AboutSection />
      <PlatformSection onInstall={handleInstall} />
      <PartnersSection />
      <ArtistMessageSection />
      <CTASection modalOpen={installModalOpen} onInstall={handleInstall} onCloseModal={() => setInstallModalOpen(false)} />
      <TextCarouselSeciton />
      <Footer />
    </>
  );
};

export default HomePage;
